import { createSelector } from '@reduxjs/toolkit';

import {
  Ticket,
  TicketApiData,
  TicketDataFromMainPage,
} from 'store/models/Ticket';
import { userDataSelector } from 'store/selectors/user.selector';

export const ticketSelector = (state) => state.ticket;
export const ticketOnLoadFormToAutosaveApiDataSelector = createSelector(
  ticketSelector,
  (storeState) => storeState.onLoadFormToAutosaveApiData,
);

export const ticketOnLoadIsUnassignedSelector = createSelector(
  ticketSelector,
  (storeState) => storeState.onLoadIsUnassigned,
);

export const ticketErrorSelector = createSelector(
  ticketSelector,
  (storeState) => storeState.error,
);
export const ticketPreviewParamsSubmittedSelector = createSelector(
  ticketSelector,
  (storeState) => storeState.previewParamsSubmitted,
);
export const ticketPreviewResultSelector = createSelector(
  ticketSelector,
  (storeState) => storeState.previewResult,
);
export const ticketIsLoadingPreviewBookingsSelector = createSelector(
  ticketSelector,
  (storeState): { [bookingNo: string]: boolean } =>
    storeState.isLoadingPreviewBookings,
);

export const ticketAnyIsLoadingPreviewBookings = createSelector(
  ticketIsLoadingPreviewBookingsSelector,
  (isLoadings: { [bookingNo: string]: boolean }): boolean => {
    const values = Object.values(isLoadings);
    if (values.length > 0) return values.findIndex((v) => !!v) > -1;
    return false;
  },
);

export const ticketIsLoadingSelector = createSelector(
  ticketSelector,
  (storeState) => storeState.isLoading,
);

export const ticketDataSelector = createSelector(
  ticketSelector,
  (ticket): TicketApiData | undefined => ticket?.data,
);

export const ticketIdSelector = createSelector(
  ticketDataSelector,
  (data) => data && data.id,
);

export const recentTicketIdSelector = createSelector(
  ticketSelector,
  ({ recentTicketId }) => recentTicketId,
);

export const ticketBookingNosFromEmailSelector = createSelector(
  ticketDataSelector,
  (data) => {
    return data?.bookingNos || [];
  },
);

export const ticketFormTicketSelector = createSelector(
  ticketSelector,
  (ticketState): TicketDataFromMainPage | null => {
    if (!ticketState.formTicket) return null;
    return { ...ticketState.formTicket };
  },
);

export const originalFormTicketSelector = createSelector(
  ticketDataSelector,
  (data): TicketDataFromMainPage | null => {
    return Ticket.apiToForm(data);
  },
);
export const canEditTicketSelector = createSelector(
  ticketDataSelector,
  userDataSelector,
  (data, user): boolean => {
    if (!data || !user) return false;
    return Ticket.canEditTicket(data, user);
  },
);

export const isLoadingSubmitBookingSelector = createSelector(
  ticketSelector,
  (storeState) => storeState.isLoadingSubmitBooking,
);

export const autoMarkIsSplitErrorSelector = createSelector(
  ticketSelector,
  (storeState) => storeState.autoMarkIsSplitError,
);

export const checkingBookingInfoSelector = createSelector(
  ticketSelector,
  (storeState) => storeState.checkingBookingInfo,
);
